import { env } from 'utils/envManager'

import type { ImageLoaderProps } from '../../types/types'

export function legacyImageLoader({ src, width }: ImageLoaderProps): string {
	const url = new URL(src, env.NEXT_PUBLIC_SITE_BASE_URL)

	// if resource has ts parameter, keep it
	const previousAssetsTs = url.searchParams.get('ts')
	const searchParams = new URLSearchParams({
		imwidth: width.toString(),
		imdensity: '1',
		ts: previousAssetsTs ?? '1', // Provisional fix to prevent akamai excessive images compression
	})
	url.search = searchParams.toString()

	return url.toString()
}
